export const SubUserTypes = {
    SHOW_SUB_USER:'SHOW_SUB_USER',
    SELECTED_SUB_USER:'SELECTED_SUB_USER',
    ADD_SUB_USER:'ADD_SUB_USER',
    DELETE_SUB_USER:'DELETE_SUB_USER',
    UPDATE_SUB_USER:'UPDATE_SUB_USER',
}